import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {LoginService} from "../login/login.service";
import {isPlatformBrowser, isPlatformServer} from "@angular/common";
import {EMPTY} from "rxjs";

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {

  ssoCode: string;
  redirectUrl: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    @Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)){
      this.route.queryParams
        .subscribe(params => {
            this.ssoCode = params.code;
            if (this.ssoCode) {
              this.loginService.loginByCode(this.ssoCode).subscribe((result) => {
                this.redirectUrl = params.redirectUrl ?? '/offer';
                this.router.navigate([this.redirectUrl]);
              });
            } else {
              this.router.navigate(['/offer']);
            }
          }
        );
    }
  }

}
